/* eslint-disable no-unused-vars */
export enum trainingFileStatus {
	OPENED = 'Aberto',
	STARTED = 'Iniciado',
	CONCLUDED = 'Concluído',
	FINISHED = 'Finalizado',
}
